export default "__VITE_ASSET__7ea19979__"